import { MapPin } from "lucide-react";

// Real-author bio card shown at the bottom of every blog post and on /about.
// This is the single biggest E-E-A-T signal on the site — named humans,
// location, real-world context, and legitimate small-business ownership.
export default function AuthorsCard({ compact = false }) {
    if (compact) {
        return (
            <div className="bg-card border border-border rounded-lg p-5" data-testid="authors-card-compact">
                <div className="text-[10px] uppercase tracking-[0.2em] text-accent mb-2">About the authors</div>
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-serif text-lg">
                        V&amp;J
                    </div>
                    <div className="text-sm text-foreground/80 leading-relaxed">
                        <span className="text-primary font-medium">Vince &amp; Jean P.</span> are a
                        husband-and-wife team and small-business owners in Central Texas. They built
                        FinCalc because they wanted a less confusing way to do their own taxes,
                        build credit, and make smarter money decisions — without the ad spam and
                        lead-capture tricks that most calculator sites bury their tools in.
                    </div>
                </div>
            </div>
        );
    }
    return (
        <section className="bg-card border border-border rounded-xl p-6 sm:p-8" data-testid="authors-card">
            <div className="text-[11px] uppercase tracking-[0.2em] text-accent mb-4">About the authors</div>
            <div className="flex items-start gap-5">
                <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-serif text-2xl">
                    V&amp;J
                </div>
                <div>
                    <div className="font-serif text-2xl text-primary leading-tight">Vince &amp; Jean P.</div>
                    <div className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground font-mono tabular">
                        <MapPin className="w-3 h-3" strokeWidth={1.5} aria-hidden="true" />
                        Central Texas · Small-business owners
                    </div>
                    <p className="mt-4 text-sm sm:text-base text-foreground/80 leading-relaxed">
                        A husband-and-wife team running a small business in Central Texas. We built
                        FinCalc because we wanted a less confusing way to do our own taxes, build
                        credit, and make smarter financial decisions — without the ad spam and
                        lead-capture tricks that most calculator sites bury their tools behind.
                    </p>
                    <p className="mt-3 text-sm sm:text-base text-foreground/80 leading-relaxed">
                        Every calculator on FinCalc is the same one we use ourselves. Every article
                        is written from that same perspective: the numbers we actually run, in
                        plain English, without trying to sell you anything.
                    </p>
                </div>
            </div>
        </section>
    );
}
